import React from 'react';
import ThirdPartyYouTube from './ThirdPartyYouTube';
import ThirdPartyVimeo from './ThirdPartyVimeo';
import ThirdPartyVideoService from '../services/ThirdPartyVideoService';

export default function ThirdPartyVideoPlayer({
  url,
  onProgress,
  onEnd,
}: {
  url: string;
  onProgress?: () => void;
  onEnd?: () => void;
}) {
  const data = ThirdPartyVideoService.getData(url);
  if (data?.type === 'youtube') {
    return <ThirdPartyYouTube onProgress={onProgress} onEnd={onEnd} url={data?.id} startTime={Number(data?.time)} />;
  } else {
    return <ThirdPartyVimeo onProgress={onProgress} onEnd={onEnd} url={data?.url || ''} />;
  }
}
